import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { InputContainer } from '@/components/form/fields/InputContainer';
import SiChevronDown from '@/icons/SiChevronDown';
import SiSearch from '@/icons/SiSearch';
import { Product } from '@/services/api/contracts/catalog/types';
import { useProducts } from '@/services/api/hooks/product';
import { useSearch } from '@/utils/search';
import { FunctionComponent, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { usePrintCurrencyString } from '@/utils/price';

interface ReplaceProductSearchProps {
  fieldId: string;
}

const ReplaceProductSearch: FunctionComponent<ReplaceProductSearchProps> = ({ fieldId }) => {
  const { setValue } = useFormContext();

  const [query, setQuery] = useState('');

  const [products] = useProducts();
  const filteredProducts = useSearch(
    products,
    ['name', 'propertyBag.properties.text', 'manufacturer.name', 'category.name'],
    query
  );

  const [selectedProduct, setSelectedProduct] = useState<Product>();

  const onProductSelect = (product: Product) => {
    setSelectedProduct(product);
    setValue(fieldId, product.id);
  };

  const printCurrencyString = usePrintCurrencyString({ forceSpecifyRegion: true });

  return (
    <InputContainer className="space-x-2 flex flex-col">
      <div className="flex w-full space-x-2 items-center border-b pb-2 px-3 py-2">
        <SiSearch className="w-6 h-6" />
        <input
          value={query}
          onChange={e => setQuery(e.target.value)}
          type="text"
          className="placeholder:text-secondary-std block flex-1 border-0 bg-transparent p-0 text-sm placeholder:opacity-60 focus:ring-0 sm:leading-6"
          placeholder="Search for replacement product"
        />
        <SiChevronDown className="w-6 h-6" />
      </div>
      <div className="w-full h-[12rem] px-3 py-2 flex">
        {filteredProducts.length === 0 ? (
          <div className="w-full flex items-center justify-center">
            <p className="font-extralight">Start typing to see products</p>
          </div>
        ) : (
          <div className="w-full overflow-y-auto space-y-1 pr-2">
            {filteredProducts.map(product => (
              <Button
                variant={selectedProduct?.id === product.id ? ButtonVariant.Primary : ButtonVariant.Mono}
                onClick={() => onProductSelect(product)}
                className="w-full justify-start"
                key={product.id}
              >
                {product.name} -{' '}
                {product.price &&
                  printCurrencyString(product.price.price, product.region?.code)}{' '}
                - {product.category.name}
              </Button>
            ))}
          </div>
        )}
      </div>
    </InputContainer>
  );
};

export default ReplaceProductSearch;
